export function passwordValidator(password, minLength = 8) {
  const hasMinLength = password.length >= minLength;
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return hasMinLength && hasUppercase && hasLowercase && hasNumber && hasSymbol;
}
